"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventProbabilityOutcomeName = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const outcomeHasParams_1 = require("../../outcomeHasParams");
const getOutcomeParameterValue_1 = require("../../getOutcomeParameterValue");
const getScoreName_1 = require("../../getScoreName");
// TODO remove after PLAT-372 release
const getEventProbabilityOutcomeName = ({ eventProbabilityOutcome, eventCompetitors, isShortNamed, transformParamValueFunc, }) => {
    var _a, _b, _c, _d;
    const name = getProbabilityOutcomeName({
        eventProbabilityOutcome,
        eventCompetitors,
        isShortNamed,
    });
    switch (true) {
        case (0, outcomeHasParams_1.outcomeHasParams)(eventProbabilityOutcome, betweb_openapi_axios_1.ParameterType.HomeScore, betweb_openapi_axios_1.ParameterType.AwayScore):
            return (0, getScoreName_1.getScoreName)(eventProbabilityOutcome);
        case (0, outcomeHasParams_1.outcomeHasParams)(eventProbabilityOutcome, betweb_openapi_axios_1.ParameterType.Value):
            return `${name} ${transformParamValueFunc(((_b = (_a = eventProbabilityOutcome.parameters) === null || _a === void 0 ? void 0 : _a.find((parameter) => parameter.type === betweb_openapi_axios_1.ParameterType.Value)) === null || _b === void 0 ? void 0 : _b.value) || '')}`;
        case (0, outcomeHasParams_1.outcomeHasParams)(eventProbabilityOutcome, betweb_openapi_axios_1.ParameterType.GoalsRange):
            return getScoreRangeName(eventProbabilityOutcome);
        case (0, outcomeHasParams_1.outcomeHasParams)(eventProbabilityOutcome, betweb_openapi_axios_1.ParameterType.PlayerId):
            return (((_d = (_c = eventProbabilityOutcome.parameters) === null || _c === void 0 ? void 0 : _c.find((parameter) => parameter.type === betweb_openapi_axios_1.ParameterType.PlayerId)) === null || _d === void 0 ? void 0 : _d.playerName) || ' ');
        default: {
            return name;
        }
    }
};
exports.getEventProbabilityOutcomeName = getEventProbabilityOutcomeName;
// TODO remove after PLAT-372 release
const getProbabilityOutcomeName = ({ eventProbabilityOutcome, eventCompetitors: { homeCompetitors, awayCompetitors }, isShortNamed, }) => {
    let { name } = eventProbabilityOutcome.outcomeTypeData;
    if (isShortNamed) {
        name = eventProbabilityOutcome.outcomeTypeData.shortName;
    }
    return (name
        // eslint-disable-next-line no-template-curly-in-string
        .replaceAll('{$competitor1}', homeCompetitors.map((c) => c.name).join(', '))
        // eslint-disable-next-line no-template-curly-in-string
        .replaceAll('{$competitor2}', awayCompetitors.map((c) => c.name).join(', ')));
};
// TODO Remove after PLAT-2815 release
const getScoreRangeName = (probWithOutcome) => `${(0, getOutcomeParameterValue_1.getOutcomeParameterValue)({
    eventProbability: probWithOutcome,
    parameterType: betweb_openapi_axios_1.ParameterType.GoalsRange,
})}`;
//# sourceMappingURL=getEventProbabilityOutcomeName.js.map